import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	width: 300px;
	padding: 20px;
	background: rgba(17, 19, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition:
		opacity 0.3s ease,
		transform 0.3s ease,
		bottom 0.3s ease;
	opacity: 0;
	transform: translate(-50%, 100%);

	&.modal-enter {
		opacity: 0;
		transform: translate(-50%, 100%);
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
		transform: translate(-50%, 0);
	}

	&.modal-exit-active {
		opacity: 0;
		transform: translate(-50%, 100%);
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 20px;

	button {
		pointer-events: none;
		padding: 0 5px;
	}
`;

const StyledButtonContent = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
`;

const StyledKeyContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: #ffffff;
	border-radius: 3px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #000000;
	}
`;

const StyledProgressWrapper = styled.div`
	position: absolute;
	bottom: 0;
	left: 9px;
	right: 9px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 2px;
	height: 2px;
	margin-top: 17px;
`;

const StyledProgress = styled.div`
	width: 100%;
	height: 2px;
	background: #fabe2c;
	border-radius: 2px;
	transform-origin: left;
	transform: scaleX(1);
	will-change: transform;
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledKeyContainer,
	StyledProgress,
	StyledProgressWrapper,
};
